import { Box } from '@mui/material'
import React, { ReactElement } from 'react'

interface PopUpMenuIconProps {
    icon: string | ReactElement
    name?: string
}

const PopUpMenuIcon = ({ icon, name = '' }: PopUpMenuIconProps) => {
    return (
        <Box mb="4px">
            {typeof icon === 'string' ? (
                <img src={icon} alt={name} />
            ) : (
                <>{icon}</>
            )}
        </Box>
    )
}

export default PopUpMenuIcon
